export default __webpack_public_path__ + "static/media/flag-nl.12e016db.svg";